import React, { createContext, useState, useContext } from 'react';

const HistoryContext = createContext();

export const useHistory = () => useContext(HistoryContext);

export const HistoryProvider = ({ children }) => {
  const [history, setHistory] = useState([]);
  const [currentPosition, setCurrentPosition] = useState(-1);

  return (
    <HistoryContext.Provider value={{ history, setHistory, currentPosition, setCurrentPosition }}>
      {children}
    </HistoryContext.Provider>
  );
};